import type { EnumUnion } from '@dresscode-frontend/utility-types';
import { z } from 'zod';
import { ListStorageRiskAlertsOrderByEnum, RiskAlertCategorySchema, RiskAlertPatternCodeSchema, RiskLevelSchema } from '@/lib/api/orpc/contracts/storage-risk-alert';
export const RiskAlertCategory = {
  PERMISSION: 'PERMISSION',
  SHARING: 'SHARING'
} as const;
export type RiskAlertCategory = EnumUnion<typeof RiskAlertCategory>;
export const Columns = {
  RISK_LEVEL: 'riskLevel',
  POLICY_TITLE: 'policyTitle',
  ITEM: 'item',
  PERMISSION_HOLDER: 'permissionHolder',
  PERMISSION_ROLE: 'permissionRole'
} as const;
export type Columns = EnumUnion<typeof Columns>;

/**
 * ユーザーが検索欄へ入力できる上限文字数。契約側 `freeText: z.string().max(200)`
 * と揃える（`RiskAlertToolbar.tsx` の `SearchInput` の `maxLength` にも使用）。
 */
export const FREE_TEXT_MAX_LENGTH = 200;

/**
 * `riskCategory` は画面が対応する2カテゴリのみ受け付ける。`DOWNLOAD` は未対応のため
 * 契約の3値から除外する（契約を単一の正とし、値セットの独立定義を避ける。M-1）。
 */
const RiskCategoryForSearchSchema = RiskAlertCategorySchema.exclude(['DOWNLOAD']);
export const SearchSchema = z.object({
  riskCategory: RiskCategoryForSearchSchema.catch(RiskAlertCategory.PERMISSION),
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce.number().int().min(1).max(2000).catch(100),
  freeText: z.string().max(FREE_TEXT_MAX_LENGTH).optional().catch(undefined),
  riskLevels: z.array(RiskLevelSchema).nonempty().optional().catch(undefined),
  patternCodes: z.array(RiskAlertPatternCodeSchema).nonempty().optional().catch(undefined),
  orderBy: ListStorageRiskAlertsOrderByEnum.optional().catch(undefined),
  orderDirection: z.enum(['asc', 'desc']).optional().catch(undefined)
});
export type SearchSchema = z.infer<typeof SearchSchema>;